import React from 'react';
import PropTypes from 'prop-types';
import { useDispatch, useSelector } from 'react-redux';

import LoadingDots from 'components/LoadingDots';
import { openModal } from 'components/Modal';
import Roster, { SORT_OPTION } from 'components/Roster';
import { schedulePropTypes } from 'constants/propTypes';
import URLS from 'constants/urls';
import { selectActiveVenue } from 'selectors/general';

import EmptyRoster from '../EmptyRoster';
import RosterListItem from '../RosterListItem';
import YieldEmptyState from '../YieldEmptyState';
import { emailMember, updateReservationAttendance } from '../YieldManagement.saga';
import { getRosterAttendanceWindow } from './ScheduleDetailV2.helpers';
import { useScheduleRoster } from './ScheduleDetailV2.hooks';
import messages from './ScheduleDetailV2.messages';

const RosterTabContent = ({ schedule }) => {
  const dispatch = useDispatch();
  const { venueId, venueName, venueSubtitle } = useSelector(selectActiveVenue);
  const { data: roster, isError, isLoading } = useScheduleRoster(schedule.scheduleId);

  if (isError) {
    return <YieldEmptyState title={messages.rosterErrorTitle} subtitle={messages.rosterErrorSubtitle} />;
  }

  if (isLoading) {
    return <LoadingDots />;
  }

  const attendanceWindow = getRosterAttendanceWindow(schedule.startDateTime);
  const rosterWithSchedule = (roster || []).map(reservation => ({ ...reservation, schedule }));

  return (
    <Roster
      className="yield-management__roster"
      name={messages.tabRoster}
      RowComponent={RosterListItem}
      getKey={item => item.reservationId}
      data={rosterWithSchedule}
      EmptyComponent={EmptyRoster}
      printHref={
        rosterWithSchedule.length ? URLS.schedule.print(venueId, schedule.scheduleId, schedule.startDate) : null
      }
      sortOptions={[SORT_OPTION.ALPHABETIC, SORT_OPTION.VISITS, SORT_OPTION.RECENT]}
      canUpdateAttendance={attendanceWindow.canUpdateAttendance}
      isScheduleAfterUpdateAttendanceTimeRange={attendanceWindow.isScheduleAfterUpdateAttendanceTimeRange}
      isScheduleBeforeUpdateAttendanceTimeRange={attendanceWindow.isScheduleBeforeUpdateAttendanceTimeRange}
      updateReservationAttendance={(reservationId, attended) =>
        dispatch(updateReservationAttendance(schedule.scheduleId, reservationId, attended))
      }
      emailMember={(...args) => dispatch(emailMember(...args))}
      openModal={(...args) => dispatch(openModal(...args))}
      venueName={venueName}
      venueSubtitle={venueSubtitle}
      noScroll
    />
  );
};

RosterTabContent.propTypes = {
  schedule: PropTypes.shape(schedulePropTypes),
};

export default RosterTabContent;
